import {
  AcceptOrder,
  AcceptOrderFromJSON,
  GetAcceptOrdersRequest,
  GetAcceptOrdersRequestToJSON,
  HTTPQuery
} from '@/api'
import * as runtime from '../runtime'

export class AcceptOrderApi extends runtime.BaseAPI {
  /**
   * 受入資料を取得する
   * 受入資料取得
   */
  async getAcceptOrders(
    request: GetAcceptOrdersRequest
  ): Promise<AcceptOrder[]> {
    const queryParameters: HTTPQuery = Object.fromEntries(
      Object.entries(GetAcceptOrdersRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery

    const response = await this.requestGet('/accept-orders', queryParameters)

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(AcceptOrderFromJSON)
    ).value()
  }
}
